import { g as d } from "../../utils-BOfnFgIH.js";
import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as o, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const f = {
  name: "DtIconTimerOff",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, m = ["aria-label", "data-qa", "aria-hidden"], c = ["clip-path"], p = ["id"];
function _(e, t, l, h, g, i) {
  return n(), o("svg", {
    "aria-label": l.ariaLabel,
    class: s([i.iconSizeClass, "d-icon d-icon--timer-off"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Timer Off",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      fill: "currentColor"
    }, [...t[0] || (t[0] = [
      a("path", { d: "M4.5 1A.5.5 0 0 1 5 .5h2a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5ZM2.492 5.038a.5.5 0 0 1 .27.654 3.5 3.5 0 0 0 .742 3.804 3.5 3.5 0 0 0 3.804.742.5.5 0 1 1 .384.924 4.5 4.5 0 0 1-4.894-.957l-.003-.003a4.5 4.5 0 0 1-.957-4.894.5.5 0 0 1 .654-.27Zm3.923-2.531A4.5 4.5 0 0 1 9.207 3.85a4.5 4.5 0 0 1 .728 5.378l1.419 1.418a.5.5 0 0 1-.708.708l-10-10a.5.5 0 1 1 .708-.708l2.418 2.42a4.5 4.5 0 0 1 2.643-.558Zm2.08 2.046a3.5 3.5 0 0 1 .697 3.932L6.5 5.793V5a.5.5 0 0 0-.968-.175L4.515 3.808a3.5 3.5 0 0 1 3.976.74l.004.005Z" }, null, -1)
    ])], 8, c),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...t[1] || (t[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, p)
    ])
  ], 10, m);
}
const S = /* @__PURE__ */ u(f, [["render", _]]);
export {
  S as default
};
//# sourceMappingURL=timer-off.js.map
